import {Component, inject, input, OnInit, signal} from '@angular/core';
import {AddressStepComponent} from "../../offer-detail/address-step/address-step.component";
import {BonusStepComponent} from "../../offer-detail/bonus-step/bonus-step.component";
import {MatStep, MatStepLabel, MatStepper} from "@angular/material/stepper";
import {MatVerticalStepperScrollerDirective} from "../../../../core/directives/mat-vertical-stepper-scroller.directive";
import {PaymentStepComponent} from "../../offer-detail/payment-step/payment-step.component";
import {RegistrationStepComponent} from "../../offer-detail/registration-step/registration-step.component";
import {SummaryStepComponent} from "../../offer-detail/summary-step/summary-step.component";
import {STEPPER_GLOBAL_OPTIONS, StepperOrientation, StepperSelectionEvent} from "@angular/cdk/stepper";
import {TranslationService} from "../../../../core/services/translation.service";
import {Offer} from "../../../../data/models/offer.model";
import {UserData} from "../../../../data/models/user-data.model";
import {OfferCardComponent} from "../offer-card.component";
import {OfferPrice} from "../../../../data/models/price.model";
import {AddressCombination} from "../../../../data/models/address-combination";
import {ConfigService} from "../../../../core/services/config.service";
import {
  configFlag,
  CONFIG_DIGITAL_ADDRESS_STEP,
  isDigitalAddressStepActive
} from "../../../../core/utils/digital-order-address";
import {VisitedSteps} from "../../../../core/utils/visited-steps";
import {ORDER_STEPPER_OPTIONS, stepIndicatorState} from "../../../../core/utils/step-indicator";

@Component({
  selector: 'app-digital-offer',
  imports: [
    AddressStepComponent,
    BonusStepComponent,
    MatStep,
    MatStepLabel,
    MatStepper,
    MatVerticalStepperScrollerDirective,
    PaymentStepComponent,
    RegistrationStepComponent,
    SummaryStepComponent,
    OfferCardComponent
  ],
  providers: [{provide: STEPPER_GLOBAL_OPTIONS, useValue: ORDER_STEPPER_OPTIONS}],
  templateUrl: './digital-offer.component.html',
  styleUrl: './digital-offer.component.css'
})
export class DigitalOfferComponent implements OnInit {
  protected readonly AddressCombination = AddressCombination;

  protected translationService = inject(TranslationService);
  private configService = inject(ConfigService);

  public offer = input.required<Offer>();
  public userData = input<UserData>();
  public currentProductAlreadyOrdered = input(false); //Bezieht der Nutzer das Produkt schon?

  stepperOrientation = input<StepperOrientation>('horizontal');
  isAuthenticated = input(false);
  isEditable = input(false);
  hideLoginBox = input(false);
  isWinback = input(false);

  paymentStepCompleted = signal(false);
  /**
   * Ob eine Online-Zahlart gewählt ist. Wird an den Zusammenfassungs-Schritt durchgereicht, damit
   * der Bestell-Button dort erst nach einer erfolgreichen Zahlung freigegeben wird.
   */
  onlinePaymentSelected = signal(false);
  addressStepCompleted = signal(false);
  registrationStepCompleted = signal(false);
  bonusStepCompleted = signal(false);

  selectedBillingAddress = null;
  selectedBonusAddress = null;
  selectedDeliveryAddress = null;

  selectedFormOfPayment = null;
  selectedPaymentFrequency = null;
  selectedStartDate = null;

  offerPrice: OfferPrice[];
  creatingOrder: boolean = false;

  /**
   * Digitale Abos haben keine Lieferadresse. Der Adress-Step erfasst hier deshalb ausschließlich die
   * Rechnungsadresse; AddressCombination.NONE blendet ihn aus.
   */
  addressCombination = signal(AddressCombination.NONE);

  ngOnInit(): void {
    this.configService.loadConfig(CONFIG_DIGITAL_ADDRESS_STEP).subscribe(config => {
      // Nutze setTimeout(0), um NG0100 zu vermeiden, falls der Config-Load synchron/sofort feuert.
      setTimeout(() => {
        const active = isDigitalAddressStepActive(this.offer(), configFlag(config, false));
        this.addressCombination.set(active ? AddressCombination.ONLY_BILLING : AddressCombination.NONE);
      });
    });
  }

  protected readonly stepIndicatorState = stepIndicatorState;

  private visitedSteps = new VisitedSteps();

  /**
   * Darf der Schritt als erledigt gelten? Erst, wenn der Kunde ihn geöffnet hat - s. VisitedSteps.
   * Ausnahme: Wer das Produkt schon bezieht, springt der Zahlart-Schritt bewusst direkt zur
   * Zusammenfassung (skipDirectlyToLastStep); dafür müssen die Schritte davor als erledigt gelten.
   */
  protected stepReached(step: MatStep, stepper: MatStepper): boolean {
    return this.currentProductAlreadyOrdered() || this.visitedSteps.isVisited(step, stepper);
  }

  stepperSelectionChanged(event: StepperSelectionEvent) {
    this.visitedSteps.track(event);
    // Wenn wir im Stepper zurückgehen, muss der Preis gelöscht werden...
    if (event.previouslySelectedIndex > event.selectedIndex) {
      // this.offerPrice = null;
      // this.showOnlinePayment = false;
      // this.agbChecked.set(false);
    }
  }

  onCompleteOrder(event) {

  }

  onOptInsSelected(event) {
  }

  protected onRegistrationStepCompleted(event: boolean) {
    this.registrationStepCompleted.set(event);
  }

  protected onPaymentStepCompleted(event: boolean) {
    this.paymentStepCompleted.set(event);
  }

  protected onOnlinePaymentSelected(event: boolean) {
    this.onlinePaymentSelected.set(event);
  }

  protected onAddressStepCompleted(event: boolean) {
    this.addressStepCompleted.set(event);
  }

  protected onBonusStepCompleted(event: boolean) {
    this.bonusStepCompleted.set(event);
  }
}
